import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
    },
  dialogContent: {
    overflowY: 'auto',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    },
        dialogActions: {
            display: "flex",
            justifyContent:"flex-end",
            padding: "8px 16px",
            borderTop: "1px solid #e0e0e0"
        },
    errorList: {
        color: theme.palette.error.main,
    },
}));

const ErrorsAlert = ({ open, errors, handleClose }) => {
    const classes = useStyles();

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle className={classes.dialogTitle}>Erreur dans la soumission du formulaire</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <ul className={classes.errorList}>
                    {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={handleClose} color="primary">
                    Fermer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ErrorsAlert.propTypes = {
    open: PropTypes.bool.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
    handleClose: PropTypes.func.isRequired,
};

export default ErrorsAlert;